import { EMPTY_LIST } from '../../../../constants/common'

/**
 * Builds the widget list render order from the backend configuration.
 *
 * Configured widgets lead in the order the backend returns them; any widget the
 * configuration omits is appended afterwards in the default order, so a partial
 * config can reorder widgets but never hide them. Unknown names stay in the list
 * and are skipped by callers that have no matching widget.
 */
export function resolveWidgetListOrder(configNames = EMPTY_LIST, defaultOrder) {
  if (configNames.length === 0) {
    return defaultOrder
  }

  const configuredKeys = new Set(configNames)

  return [
    ...configNames,
    ...defaultOrder.filter(key => !configuredKeys.has(key)),
  ]
}
